<template>
  <div
    class="flex min-h-full flex-col items-center justify-center px-6 py-12 lg:px-8 login-bg max-w-lg mx-auto mx-2 rounded-md"
  >
    <div class="d-flex flex-column align-items-center justify-content-center">
      <div class="logo text-center my-4">
        <router-link to="/" class="logo mt-4 pt-4">
          <img
            v-if="theme == 'light'"
            src="@/assets/img/logo/logo-h-w-light.webp"
            width="240px"
            alt="logo"
          />
          <img
            v-if="theme == 'dark'"
            src="@/assets/img/logo/logo-h-w-dark.webp"
            width="240px"
            alt="logo"
          />
        </router-link>
      </div>
    </div>

    <!-- Add Loading component -->
    <div class="mt-4 mb-4 py-4 d-flex flex-column align-items-center">
      <h1 class="fs-4 fw-semibold text-white mb-4">
        <span v-if="$route.params.status === 'payment-success'">
          ✅ {{ $t("Payment Successful") }} 🎉
        </span>
        <span v-else>
          ❌ {{ $t("Payment Failed") }}
        </span>
      </h1>

      <p>
        <span v-if="$route.params.status === 'payment-success'">
          {{ $t("Thank you for your subscription") }}!
        </span>
        <span v-else>
          {{ $t("Your payment was not completed. Please try again.") }}
        </span>
      </p>
    </div>

  </div>
</template>

<script>
import { mapState } from "pinia";
import { useHomeStore } from "@/store/home";

export default {
  methods: {
    // ...mapActions(useAuthStore, ["verifyPayment"]),
  },
  computed: {
    ...mapState(useHomeStore, ["theme"]),
  },

  async mounted() {
    const status = this.$route.params.status ?? "none";
    if (status === 'payment-success') {
      setTimeout(() => {
        const redirectUrl = localStorage.getItem('redirectUrl');
        if (redirectUrl) {
          this.$router.push(redirectUrl);
        } else {
          this.$router.push('/');
        }
      }, 1500);
    }

    // No need to manual verify since its passed in the webhook
    // const sessionId = new URLSearchParams(window.location.search).get("session_id");
    // if (status === 'payment-success' && sessionId) {
    //   try {
    //     await this.verifyPayment(sessionId);
    //   } catch (error) {
    //     console.error('Payment Verification Failed:', error);
    //   }
    // }
  },
};
</script>

<style></style>
